const getters = {
  isLoading: state => state.app.isLoading,
  suppressGlobalLoading: state => state.app.globalLoadingSuppressors > 0,
  device: state => state.app.device,
  user: state => state.app.user,
  client: state => state.app.client,
  token: state => state.user.token,
  riskDevice: state => state.app.riskDevice,
  riskDeviceId: state => state.app.riskDeviceId,
  retryFaceCapture: state => state.app.retryFaceCapture
}

export default getters
